import { useEffect, useState } from 'react';

export default function SiteEngineeringOverlay() {
  const [open, setOpen] = useState(false);
  const [sequenceState, setSequenceState] = useState<0 | 1 | 2>(0);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
        setSequenceState(0);
        return;
      }

      const key = event.key.toLowerCase();

      if (sequenceState === 0) {
        if (event.shiftKey && key === 'e') {
          setSequenceState(1);
        }
        return;
      }

      if (sequenceState === 1) {
        if (key === 'i') {
          setSequenceState(2);
        } else if (event.shiftKey && key === 'e') {
          setSequenceState(1);
        } else {
          setSequenceState(0);
        }
        return;
      }

      if (sequenceState === 2) {
        if (key === 'i') {
          setOpen((prev) => !prev);
        }
        setSequenceState(0);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [sequenceState]);

  if (!open) {
    return (
      <span className="sr-only" aria-hidden>
        Press Shift+E, then I, then I to open the engineering appendix.
      </span>
    );
  }

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center px-4" role="dialog" aria-modal="true">
      <div className="w-full max-w-2xl bg-white dark:bg-dark-surface border border-border dark:border-dark-border rounded-lg p-7">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-serif text-2xl text-primary-text dark:text-dark-primary-text">How this site is engineered</h2>
          <button type="button" onClick={() => setOpen(false)} className="text-sm text-primary underline">
            Close
          </button>
        </div>
        <div className="space-y-4 text-sm text-secondary-text dark:text-dark-secondary-text leading-relaxed">
          <p>Progressive revelation is intentional: core credibility first, deeper systems context on interaction.</p>
          <p>Enhancements prioritize explainability and decision rationale over decorative effects.</p>
          <p>Technical appendix: React + Vite + Tailwind, dark mode aware, no autoplay behaviors, minimal-motion interaction patterns.</p>
        </div>
      </div>
    </div>
  );
}
